import { Component, OnInit } from '@angular/core';
import { SignalrService } from '../services/singalr.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
  chatModel= {
    message: ''
  };
  user = {
    id : '',
    type: '',
    messgage: ''
  }
  constructor(
    private signalRService: SignalrService

  ) { }

  ngOnInit() {
    // this.registerUser();
    debugger;

  }
  sendMessage() {
    debugger;
    const user = JSON.parse(localStorage.getItem('user'));
    // this.signalRService.SendPrivateMessage(user.id,  user.type, this.chatModel.message);
    this.signalRService.SendPrivateMessage(0,  'customerService', this.chatModel.message);

  }
  sendPrivateMessage() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.signalRService.sendPrivateMessage(user.id, user.Name, user.type, 'hi from customer service');
  }
  // registerUser() {
  //   this.signalRService.broadcastMessage();
  // }
}
